// Construct a query string with the query parameter if it exists.
export const constructQueryString = (params: { [key: string]: string }): string => {
	const queryParams = new URLSearchParams(params).toString();
	return queryParams ? `?${queryParams}` : '';
};
